// Phase 9 R3 — Single inventory item fetch for linked-row context display.
// Shop-scoped key; React Query dedupes across multiple linked rows.
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import type { InventoryItem } from './useInventoryItems';

export function useInventoryItemById(itemId: string | null | undefined) {
  const { activeShop } = useAuth();
  const shopId = activeShop?.id;
  return useQuery({
    queryKey: ['inventory-item', shopId, itemId] as const,
    enabled: !!shopId && !!itemId,
    queryFn: async (): Promise<InventoryItem | null> => {
      if (!shopId || !itemId) return null;
      const { data, error } = await supabase
        .from('inventory_items')
        .select('*')
        .eq('shop_id', shopId)
        .eq('id', itemId)
        .maybeSingle();
      if (error) throw error;
      return (data as InventoryItem) ?? null;
    },
    staleTime: 30_000,
  });
}
